<div class="ipm-diwali-sale-home" [class.ipm-sale-inactive]="!isSaleActive">
  <div class="ipm-bottom-gradient"></div>
    <div class="ipm-diwali-container">
      <div class="diwali-logo-section" *ngIf="isSaleActive">
        <ng-lottie  [options]="optionsBpm"></ng-lottie> 
      </div>
      <div class="ipm-content-main-container">
        <ng-conatiner *ngIf="isSaleActive">
           <p class="ipm-text-sub-heading" [class.blinking-text]="isSaleActive">{{isSaleActive ? 'SALE IS LIVE' : '21st Oct | 6–7 PM — BPM Diwali Hour Sale Goes Live!'}}</p>
        <p class="ipm-text-sub-beat-sale-heading">⚡ 3 Hour Sale: Beats & Subscription Plans Up to 50% OFF</p>
        <p class="ipm-text-sub-beat-sale-heading" *ngIf="isSaleActive">DIWALI HOUR SALE ENDS IN</p>
        <div class="flip-clock">
              <!-- Days -->
              <div class="flip-clock__piece">
                <div class="card-container">
                  <div class="card" [class.flip]="flipStates.days">
                    <span class="count curr top">{{ countdown.days | padNumber }}</span>
                    <span class="count next top">{{ nextCountdown.days | padNumber }}</span>
                    <span class="count next bottom">{{ nextCountdown.days | padNumber }}</span>
                    <span class="count curr bottom">{{ countdown.days | padNumber }}</span>
                  </div>
                </div>
                <div class="flip-clock__slot">DAYS</div>
              </div>

              <div class="separator">|</div>

              <!-- Hours -->
              <div class="flip-clock__piece">
                <div class="card-container">
                  <div class="card" [class.flip]="flipStates.hours">
                    <span class="count curr top">{{ countdown.hours | padNumber }}</span>
                    <span class="count next top">{{ nextCountdown.hours | padNumber }}</span>
                    <span class="count next bottom">{{ nextCountdown.hours | padNumber }}</span>
                    <span class="count curr bottom">{{ countdown.hours | padNumber }}</span>
                  </div>
                </div>
                <div class="flip-clock__slot">HOURS</div>
              </div>

              <div class="separator">|</div>

              <!-- Minutes -->
              <div class="flip-clock__piece">
                <div class="card-container">
                  <div class="card" [class.flip]="flipStates.minutes">
                    <span class="count curr top">{{ countdown.minutes | padNumber }}</span>
                    <span class="count next top">{{ nextCountdown.minutes | padNumber }}</span>
                    <span class="count next bottom">{{ nextCountdown.minutes | padNumber }}</span>
                    <span class="count curr bottom">{{ countdown.minutes | padNumber }}</span>
                  </div>
                </div>
                <div class="flip-clock__slot">MINUTES</div>
              </div>
              <div class="separator">|</div>

              <!-- Seconds -->
              <div class="flip-clock__piece">
                <div class="card-container">
                  <div class="card" [class.flip]="flipStates.seconds">
                    <span class="count curr top">{{ countdown.seconds | padNumber }}</span>
                    <span class="count next top">{{ nextCountdown.seconds | padNumber }}</span>
                    <span class="count next bottom">{{ nextCountdown.seconds | padNumber }}</span>
                    <span class="count curr bottom">{{ countdown.seconds | padNumber }}</span>
                  </div>
                </div>
                <div class="flip-clock__slot">SECONDS</div>
              </div>
        </div>

        </ng-conatiner>
       

        <div class="ipm-banner-text">
          <h1>YOUR NEXT HIT AWAITS! <br>START EXPLORING
              <img priority src="./assets/imgs/beat-play-icon.webp" alt="beat-play-icon" width="24" height="18">
              <b>BEATS</b> NOW
          </h1>
        </div>

        <div class="search-box-wrapper">
          <div class="ipm-search-box">
            <input type="search" class="form-control" placeholder="Search top beats" id="search-diwali-section"
              name="search-diwali-section" [(ngModel)]="commonService.selectedSearchInputValue"
              (search)="onChangeSearchValue($event)" (keyup.enter)="onChangeSearchValue($event)"
              aria-label="Search filter" [ngModelOptions]="{standalone: true}" #searchInputValue>
            <p-dropdown id="searchFilterDiwali" [options]="commonService.searchFilterType"
              [(ngModel)]="commonService.selectedSearchType" optionLabel="label" placeholder=""
              aria-label="Search filter" (ngModelChange)="onChangeSearchValue($event)" [className]="'ipm-dropdown'">
            </p-dropdown>
          </div>
          <ipm-button [buttonName]="'Search'" [borderGradient]="true"
            (onClickEvent)="onClickSearch(searchInputValue.value)">
          </ipm-button>
        </div>
          <!-- Quick Filter Buttons -->
        <div class="quick-filter-buttons">
          <a href="javascript:void(0);" routerLink="/beats" class="quick-filter-btn">
            All Beats
          </a>
          <a href="javascript:void(0);" [routerLink]="['/playlists']" class="quick-filter-btn">
            Beat Playlists
          </a>
          <a href="javascript:void(0);" routerLink="/playlist/newfinds" class="quick-filter-btn">
            New Finds
          </a>
        </div>
      </div>
      
    </div>
</div>